module.exports = __webpack_public_path__ + "media/images/weather-icons/fill/partly-cloudy-day-rain-4c0668cce0f70c7678d55a2b1e7227f7.svg";